import { User } from "../../shared/lib/types/Types";

export enum UserAuthActionTypes {
    FETCH_DATA_REQUEST_USER_ACCOUNT = 'FETCH_DATA_REQUEST_USER_ACCOUNT',
    FETCH_DATA_RESPONSE_USER_ACCOUNT = 'FETCH_DATA_RESPONSE_USER_ACCOUNT',
    FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR = 'FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR',
    FETCH_DATA_USER_ACCOUNT_LOGOUT = 'FETCH_DATA_USER_ACCOUNT_LOGOUT'
  }
  
  interface UserAuthLoadingAction {
    type: UserAuthActionTypes.FETCH_DATA_REQUEST_USER_ACCOUNT;
  }
  
  interface UserAuthSuccessAction {
    type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT;
    payload: User;
  }
  
  interface UserAuthErrorAction {
    type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR;
    payload: string | null;
  }
  
  interface UserAuthLogoutAction {
    type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT;
  }

  export type UserAuthTypeAction = UserAuthLoadingAction | UserAuthSuccessAction | UserAuthLogoutAction | UserAuthErrorAction